import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdEditorComponent } from './md-editor/md-editor.component';
import { MonacoEditorModule } from '@materia-ui/ngx-monaco-editor';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [MdEditorComponent],
  exports: [MdEditorComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    MonacoEditorModule,
    FormsModule,
    MatIconModule,
  ],
})
export class EditorModule {}
